import React, { useState } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import useViewSettings from "../api/useViewSettings";
import SearchIcon from "@material-ui/icons/Search";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Grid from "@material-ui/core/Grid";
import { baseurl_documentdata, msg_no_selection } from "../conf/settings";
import SnackAlert from "./SnackAlert";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: "1rem",
  },
  search: {
    position: "relative",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    border: "1px",
    width: "100%",
  },
  inputInput: {
    border: "1px solid lightgrey",
    borderRadius: "4px",
    padding: theme.spacing(1, 1, 1, 5),
  },
}));

export default function ViewTemplate({ server, replicaid, viewname, search, select, deletion, expand, grouping }) {
  const classes = useStyles();
  const [reload, toggleReload] = useState(false);
  const [gridApi, setGridApi] = useState({});
  const [quickFilterText, setQuickFilterText] = useState("");
  const [rowData, colDefs, gridSettings] = useViewSettings(server, replicaid, viewname, reload);
  const [showMsg, setShowMsg] = useState(false);

  const showSearch = search !== null ? true : false;
  const showDelete = deletion !== null ? true : false;
  const showExpand = expand !== null ? true : false;
  const showGrouping = grouping !== null ? true : false;
  const showSelect = select !== null ? true : false;
  const rowSelection = "multiple";

  console.log("search", showSearch);
  console.log("delete", showDelete);
  console.log("expand", showExpand);
  console.log("grouping", showGrouping);
  console.log("select", showSelect);

  const isFirstColumn = (params) => {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    return displayedColumns[0] === params.column;
  };

  const defColDef = gridSettings.defaultColDefs;
  if (defColDef) {
    defColDef.headerCheckboxSelection = showSelect ? isFirstColumn : false;
    defColDef.checkboxSelection = showSelect ? isFirstColumn : false;
  }

  const [defaultColDef] = useState(defColDef);

  const styleSearch = {
    paddingTop: "1rem",
  };

  const style = {
    background: "rgb(255,255,255)",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    paddingBottom: "1rem",
    height: "65vh",
  };

  const onQuickFilterText = (event) => {
    setQuickFilterText(event.target.value);
  };

  const onCellClicked = (params) => {
    if (params.data) {
      if (params.data.unid) {
        console.log("NotesView::onCellClicked unid ", params.data.unid);
      }
    }
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.closeToolPanel();
    params.api.setSideBarPosition("left");
  };

  const onFirstDataRendered = (params) => {
    if (params) {
      params.api.expandAll();
      params.api.sizeColumnsToFit();

      var colIds = [];
      params.columnApi.getAllColumns().forEach(function (column) {
        colIds.push(column.colId);
      });
      params.columnApi.autoSizeColumns(colIds);

      params.api.collapseAll();
    }
  };

  const onRowDataChanged = (params) => {
    onFirstDataRendered(params);
  };

  const deleteData = async (selectedRows) => {
    const allPromises = [];

    if (selectedRows) {
      selectedRows.forEach((row) => {
        if (row) {
          if (row.data && row.data.unid) {
            const url = `${server}/${baseurl_documentdata}/${replicaid}/${row.data.unid}`;
            allPromises.push(axios.delete(url));
          }
        }
      });
    }

    const response = await Promise.all(allPromises);
    console.log(response);

    toggleReload(!reload);
  };

  const onBtnDeleteClicked = () => {
    var selectedRows = gridApi.getSelectedNodes();

    if (!selectedRows || selectedRows.length === 0) {
      console.log("no rows selected");
      setShowMsg(true);
      return;
    }

    deleteData(selectedRows);
  };

  return (
    <div className="notesview">
      {showMsg ? <SnackAlert msg={msg_no_selection} severity="info" setShowMsg={setShowMsg} /> : null}
      <Grid container style={styleSearch}>
        <Grid item xs></Grid>
        <Grid item xs={8}>
          <Grid item>
            {showSearch && (
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  id="quickFilter"
                  onChange={onQuickFilterText}
                  placeholder={gridSettings.filterPlaceholder}
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  inputProps={{ "aria-label": "search" }}
                />
              </div>
            )}
          </Grid>
        </Grid>
        <Grid item xs></Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Grid item>
            {showExpand && (
              <IconButton
                color="primary"
                fontSize="large"
                aria-label="expand"
                onClick={() => {
                  gridApi.expandAll();
                }}
              >
                <ExpandMoreIcon />
              </IconButton>
            )}
            {showExpand && (
              <IconButton
                color="primary"
                fontSize="large"
                aria-label="expand"
                onClick={() => {
                  gridApi.collapseAll();
                }}
              >
                <ExpandLessIcon />
              </IconButton>
            )}
            {showDelete && (
              <IconButton color="primary" fontSize="large" aria-label="delete" onClick={onBtnDeleteClicked}>
                <DeleteIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Grid>

      <div className="ag-theme-balham" style={style}>
        <AgGridReact
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          rowData={rowData}
          // listening for events
          onGridReady={onGridReady}
          onFirstDataRendered={onFirstDataRendered}
          onRowDataChanged={onRowDataChanged}
          onCellClicked={onCellClicked}
          // binding to simple properties
          sideBar={showGrouping ? gridSettings.sideBar : false}
          quickFilterText={quickFilterText}
          // group panel
          suppressDragLeaveHidesColumns={true}
          suppressMakeColumnVisibleAfterUnGroup={true}
          rowGroupPanelShow={gridSettings.rowGroupPanelShow}
          // localization
          // localeText={gridSettings.deLocaleText}
          // icons
          icons={gridSettings.icons}
          // row selection
          rowSelection={rowSelection}
          //rowModelType={rowModelType}
        ></AgGridReact>
      </div>
    </div>
  );
}
